export default (data: any, time: number): Promise<{ data: any }> => {
  return new Promise((resolve) => setTimeout(() => resolve(data), time));
};
